import { Component, type ReactNode } from 'react';
import filterLoadingFailedFlag from '@atlassian/jira-copy-filters-modal/src/common/ui/flags/filter-loading-failed/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { FlagService } from '@atlassian/jira-flags';
import type { CopyableFilter } from '../../common/types';

type State = {
	loading: boolean;
	error: Error | undefined;
	data: CopyableFilter | undefined;
};

type Props = {
	readonly id: string;
	readonly children: (props: State) => ReactNode;
	readonly flagService: FlagService;
	readonly onDataRetrieveFailed: () => void;
	readonly isAdmin?: boolean;
};

// eslint-disable-next-line jira/react/no-class-components
class FilterDataProvider extends Component<Props, State> {
	state: State = {
		loading: true,
		error: undefined,
		data: undefined,
	};

	componentDidMount() {
		this.fetchData();
	}

	async fetchData() {
		const { id, isAdmin } = this.props;

		try {
			const data = await performGetRequest(
				`/rest/api/2/filter/${id}${isAdmin ? '?overrideSharePermissions=true' : ''}`,
			);

			this.setState({ loading: false, error: undefined, data });
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			this.setState({ loading: false, error: e }, () => {
				this.showErrorFlag();
			});
		}
	}

	showErrorFlag() {
		const { flagService, onDataRetrieveFailed } = this.props;
		flagService.showFlag(filterLoadingFailedFlag());
		onDataRetrieveFailed();
	}

	render() {
		const { children } = this.props;
		const { loading, error, data } = this.state;

		return children({
			loading,
			error,
			data,
		});
	}
}

export default FilterDataProvider;
